var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"bank-account-details__top"},[_c('BankAccountList',{attrs:{"accounts":_vm.bankAccounts,"mandates":_vm.mandates}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }